import { DEFAULT_OGC_WMS_DPI, ILatitudeAndZoom, METERS_PER_INCH, METERS_PER_PX_AT_EQUATOR } from "form/map/model"
import { Map } from "mapbox-gl"
import { getLatitudeInRadian } from "./common"

// returns meters per pixel
export function getMapResolution(map: Map): number {
  return getResolution({ map, latitude: map.getCenter().lat, zoom: map.getZoom() })
}

// returns meters per pixel
export function getResolution(params: ILatitudeAndZoom): number {
  return (
    (METERS_PER_PX_AT_EQUATOR * Math.cos(getLatitudeInRadian(params.map, params.latitude))) /
    Math.pow(2, typeof params?.zoom === "number" ? params?.zoom : params.map.getZoom())
  )
}

export function getScreenResolutionInMeters(): number {
  return (1 / DEFAULT_OGC_WMS_DPI) * METERS_PER_INCH
}
